import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (!environment.isDevelopment) {
  window.console.log = (): void => {
    // Disables console.log() in production. To log in production, use console.info() if necessary.
  };
}

bootstrapApplication(AppComponent, appConfig).catch((error) => console.error(error));
